import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@cinch-labs/design-system";
const TextFieldWrapper = ({ errorDisplay ="realtime" , input , meta , onBlur , tooltip , label , inputRef , ...rest })=>/*#__PURE__*/ _jsx(TextField, {
        ...rest,
        label: label,
        id: rest["id"],
        name: input.name,
        type: input.type ? input.type : "text",
        value: input.value,
        onChange: input.onChange,
        onBlur: (e)=>{
            input.onBlur(e);
            if (onBlur) onBlur(e);
        },
        onFocus: input.onFocus,
        ref: inputRef
    });
export default TextFieldWrapper;
